/**
 * What the Zoho callback said, read once.
 *
 * The callback redirects to /settings?zoho=… and the panel lands on the list,
 * not on the Zoho screen — so both need to see this, and neither can own it.
 * The parameter is taken out of the address straight away: left there, a
 * reload would keep reporting a problem the agent has already fixed.
 */
function read(): string {
  if (typeof window === 'undefined') return ''

  const params = new URLSearchParams(window.location.search)
  const value = params.get('zoho') ?? ''
  if (!params.has('zoho')) return ''

  params.delete('zoho')
  const rest = params.toString()
  window.history.replaceState({}, '', window.location.pathname + (rest ? `?${rest}` : ''))
  return value
}

let result = read()
const listeners = new Set<() => void>()

export function getZohoCallbackResult() {
  return result
}

/**
 * Called when the agent acts on it — reconnecting is the fix, and a warning
 * that outlives the fix is worse than no warning. Without this the settings
 * list kept the "Wrong help desk" badge for the rest of the session, because
 * the OAuth happens in a second tab and the panel never reloads.
 */
export function clearZohoCallbackResult() {
  if (!result) return
  result = ''
  listeners.forEach((fn) => fn())
}

export function watchZohoCallbackResult(fn: () => void) {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}
